import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthorizationUrl, isAuthenticated } from '../utils/auth';
import './Login.css';

function Login() {
  const navigate = useNavigate();

  // 이미 로그인되어 있으면 메인 페이지로 리다이렉트
  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  const handleLogin = () => {
    const authUrl = getAuthorizationUrl();
    window.location.href = authUrl;
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Beyless 석식 기록앱</h1>
          <p>로그인이 필요합니다</p>
        </div>

        <div className="login-content">
          <div className="login-info">
            <svg className="lock-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
            <p>NaverWorks 계정으로 로그인하여<br />서비스를 이용하실 수 있습니다</p>
          </div>

          <button className="login-button" onClick={handleLogin}>
            <svg className="naver-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path fill="currentColor" d="M16.273 12.845L7.376 0H0v24h7.727V11.155L16.624 24H24V0h-7.727v12.845z"/>
            </svg>
            NaverWorks로 로그인
          </button>

          <div className="login-notice">
            <p className="notice-text">
              <strong>보안 안내</strong><br />
              NaverWorks SSO를 통해 안전하게 로그인됩니다.<br />
              귀하의 비밀번호는 저장되지 않습니다.
            </p>
          </div>
        </div>

        <div className="login-footer">
          <p>© 2024 Beyless 엣지플랫폼팀. Powered by NaverWorks</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
